import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CardContent, Card as MUICard, Typography } from '@mui/material';
import { ICard } from 'src/types/boards-lists';

export const SortableCard = ({
  card,
  data,
}: {
  card: ICard;
  data?: any;
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: card.id,
    data,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: isDragging ? 'grabbing' : 'grab',
  };

  return (
    <MUICard
      ref={setNodeRef}
      style={style}
      sx={{
        mb: 1,
        borderRadius: 1,
        boxShadow: isDragging
          ? '0 4px 10px rgba(0,0,0,0.25)'
          : '0 1px 3px rgba(0,0,0,0.1)',
      }}
      variant="outlined"
      {...attributes}
      {...listeners}
    >
      <CardContent sx={{ px: 2, py: 1 }}>
        <Typography variant="body2" fontWeight={500} noWrap>
          {card.content}
        </Typography>
      </CardContent>
    </MUICard>
  );
};
